import type { OrderSavingsResult } from 'entities/Order/lib/calculateOrderSavings/calculateOrderSavings';

export function hasOrderSavings(
    canSeePrices: boolean,
    orderSavings: OrderSavingsResult,
): boolean {
    return (
        canSeePrices &&
        orderSavings.itemsCount > 0 &&
        orderSavings.totalSavings > 0
    );
}
